import React from "react";
import "./AlertPopUp.css";
import logo from "../../../assets/Nexum-Marchio.png";

interface AlertProps {
  message: React.ReactNode;
  onClose: () => void;
}

const PopupVideo: React.FC<AlertProps> = ({ message, onClose }) => {
  const handleClick = () => {
    onClose();
  };

  return (
    <div className="alert-overlay">
      <div className="alert">
        <div className="alert-headerVideo">
          <video style={{ width: "70em" }} controls>
            <source
              src={
                `https://storage.googleapis.com/${process.env.REACT_APP_STORAGE_BUCKET}/demo-nexbot.mp4`
              }
              type="video/mp4"
            />
            Il tuo browser non supporta il tag video.
          </video>
        </div>
        <div className="alert-body">{message}</div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button className="onCloseButton" onClick={handleClick}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupVideo;
